import React, { useState } from 'react';
import { Space, notification, Typography, Popconfirm } from 'antd';

import CustomButton from '../../../../components/CustomButton';
import SpinLoad from '../../../../components/SpinLoad';
import MESSAGES from '../../../../enums/Messages';
import {
  post,
  sendMassRejectEmail,
} from '../../../../api/module/announcement_preselection_email';
import AjaxTable from '../../../../components/AjaxTable';
import { ajaxTable as filterAjaxTable } from '../../../../api/module/announcement_preselection';
import { catchExceptionSRate } from '../../../../utils/helpers/helpers';

const { Paragraph } = Typography;

const Rechazados = ({
  announcement_id,
  announcement_rol_id,
  advancedSearch,
  onRefresh,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [reloadSource, setReloadSource] = useState(false);
  const columns = [
    {
      title: 'Correo electrónico',
      dataIndex: 'notificacion_email',
      align: 'center',
    },
    {
      title: 'Nombres y Apellidos',
      dataIndex: 'nombres_apellidos',
      align: 'center',
    },
    {
      title: 'Tipo Identificación',
      dataIndex: 'identificacion',
      align: 'center',
    },
    {
      title: 'Enviar Correo notificación',
      dataIndex: 'estado_preseleccion',
      key: 'estado_preseleccion',
      render: (_, record) => (
        <Space>
          <Popconfirm
            okText="Sí"
            cancelText="No"
            title={MESSAGES.MSG_SEND_EMAIL}
            onConfirm={(e) => {
              sendEmail(record.id);
            }}
          >
            <CustomButton
              block
              type="default"
              htmlType={'button'}
              className={'ant-btn-info'}
              loading={isLoading}
              text="Generar correo"
            />
          </Popconfirm>
          {record.estado_envio_rechazado && (
            <Paragraph style={{ marginBottom: 0 }}>Enviado</Paragraph>
          )}
        </Space>
      ),
    },
  ];

  const sendEmail = async (id) => {
    try {
      setIsLoading(true);
      let data = {
        convocatoria_tercero: id,
        convocatoria: announcement_id,
        estado_tercero: 13,
      };
      await post(data);
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        duration: 2,
      });
      setReloadSource({});
      setIsLoading(false);
    } catch (err) {
      catchExceptionSRate(err, MESSAGES.DESC_ERROR_POST_MSG);
      setIsLoading(false);
    }
  };

  const massSendEmail = async () => {
    try {
      setIsLoading(true);
      await sendMassRejectEmail(announcement_id);
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        duration: 2,
      });
      setReloadSource({});
      setIsLoading(false);
    } catch (err) {
      catchExceptionSRate(err, MESSAGES.DESC_ERROR_POST_MSG);
      setIsLoading(false);
    }
  };

  return (
    <>
      <CustomButton
        text="Rechazo masivo"
        type="danger"
        onClick={massSendEmail}
        htmlType="button"
        loading={isLoading}
      />
      <AjaxTable
        columns={columns}
        pageSize={10}
        tableTitle={'Listado de contratistas rechazados'}
        endpoint={filterAjaxTable}
        searchInput
        exportCSV
        reloadButton
        query={{
          convocatoria_rol: announcement_rol_id,
          estado_tercero: 13,
          advanced_search: advancedSearch,
        }}
        reloadSource={reloadSource}
        setCount={onRefresh}
        showSizeChanger
      />
    </>
  );
};

export default Rechazados;
